export default __webpack_public_path__ + "static/media/undraw_date_picker_gorr.81df552e.svg";